import { EXTERNAL_URL_REGEX } from './constants';

const isExternalUrl = theUrl => EXTERNAL_URL_REGEX.test(theUrl);

export default isExternalUrl;
